import Layout from "../../Layouts"

const TeacherDashboard = () => {
  return (
    <Layout label="Dashboard">
      <p>Dashboard here</p>
    </Layout>
  )
}

export default TeacherDashboard